export default "__VITE_ASSET__d6a0c569__"